export default __webpack_public_path__ + "static/kz-2f2b894c6c0053ad1219fc46328cb0a7.png";